import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

const WhyInfinity = () => {
  const { t } = useTranslation();

  const blocks = [
    {
      key: 'why0',
      title: t('why0Title'),
      desc: t('why0Desc'),
    },
    {
      key: 'why1',
      title: t('why1Title'),
      desc: t('why1Desc'),
    },
    {
      key: 'why2',
      title: t('why2Title'),
      desc: t('why2Desc'),
    },
    {
      key: 'why4',
      title: t('why4Title'),
      desc: t('why4Desc'),
    },
  ];

  return (
    <>
      <Helmet>
        <title>Infinity Energy Solar – Why Infinity</title>
      </Helmet>
      <div className="pt-24 px-6 pb-16 text-[#173861]">
        <h1 className="text-4xl font-bold text-center mb-6">{t('whyHero')}</h1>
        <p className="max-w-3xl mx-auto text-lg text-center mb-12">
          {t('whyIntro')}
        </p>

        <div className="grid gap-8 max-w-5xl mx-auto">
          {blocks.map((block) => (
            <div key={block.key} className="group relative overflow-hidden rounded-xl bg-white shadow-md border border-green-600 hover:border-green-600 transition duration-300 transform hover:-translate-y-1 p-6 text-lg leading-relaxed">
              <span className="font-bold">{block.title}</span> – {block.desc}
              <div className="absolute bottom-0 left-0 w-full h-2 bg-green-600"></div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default WhyInfinity;
